import axios from 'axios'
import auth from "@/api/auth";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000
})

service.interceptors.request.use(
  config => {
    config.headers['license'] = window._pg?.license || process.env.VUE_APP_LICENSE
    if (auth.isAuthenticated()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + auth.getToken();
    }
    return config
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response !== undefined) {
      if (error.response.status === 401) {
        console.log('Unauth');
      }
    }
    // console.error('request.js', error);
    return Promise.reject(error)
  }
)

export default service
